// Traverse the DOM up until finding parent matching
export const findFirstParentMatching = (element: Element, selector: string): HTMLElement | null => {
  if (!element || !selector) {
    return null;
  }

  let current = element.parentElement;
  while (current) {
    if (current.matches(selector)) {
      return current;
    }
    current = current.parentElement;
  }

  return null;
};
